<template>
  <footer
    class="footer"
    style="background-color: black; padding: 0px; width: 100%; "
  >
    <div class="md-layout" style="min-height: 200px">
      <div class="md-layout-item md-size-20 md-small-size-100">
        <ul>
          <li>
            &nbsp;&nbsp;
          </li>
        </ul>
      </div>
      <div class="md-layout-item md-size-60 md-small-size-100">
        <div
          class="md-layout-item md-size-100 md-small-size-100"
          style="text-align: center"
        >
          <ul>
            <li style="margin-right: -20px">
              <a
                href="https://apps.apple.com/ca/app/rpas-wilco-drone-flight-plans/id1489553409"
                target="_blank"
              >
                <img
                  src="img/storeapple.png"
                  alt="APPLE STORE"
                  title="APPLE STORE"
                  style="width: 90%"
                />
              </a>
            </li>
            <li style="margin-right: -20px">
              <a
                href="https://play.google.com/store/apps/details?id=com.wilco"
                target="_blank"
              >
                <img
                  src="img/storegoogle.png"
                  alt="PLAY STORE"
                  title="PLAY STORE"
                  style="width: 90%"
                />
              </a>
            </li>
          </ul>
        </div>
        <div
          class="md-layout-item md-size-100 md-small-size-100"
          style="text-align: center"
        >
          <ul>
            <li style="margin-right: -20px">
              <a href="https://www.facebook.com/rpaswilco" target="_blank">
                <img
                  src="https://img.icons8.com/fluency/28/000000/facebook.png"
                />
              </a>
            </li>
            <li style="margin-right: -20px">
              <a href="https://www.instagram.com/rpaswilco/" target="_blank">
                <img
                  src="https://img.icons8.com/fluency/28/000000/instagram-new.png"
                />
              </a>
            </li>
            <li style="margin-right: -20px">
              <a
                href="https://www.youtube.com/channel/UC41eWMlFrrF0pcCRhgiYF3Q"
                target="_blank"
              >
                <img
                  src="https://img.icons8.com/fluency/28/000000/youtube-play.png"
                />
              </a>
            </li>
            <li style="margin-right: -20px">
              <a
                href="https://www.linkedin.com/company/rpaswilco"
                target="_blank"
              >
                <img
                  src="https://img.icons8.com/fluency/28/000000/linkedin.png"
                />
              </a>
            </li>
          </ul>
        </div>
        <div
          class="md-layout-item md-size-100 md-small-size-100"
          style="text-align: center"
        >
          <a
            href="https://aimrobotics.io/"
            target="_blank"
            style="color: white;"
            >&copy; {{ new Date().getFullYear() }} by Artificial Intelligence
            Mastermind Robotics Inc.</a
          >
        </div>
        <div
          class="md-layout-item md-size-100 md-small-size-100"
          style="text-align: center"
        >
          <ul style="color:azure;">
            <li>
              <a href="#/privacy" target="_blank">
                {{ $t("Privacy") }}
              </a>
            </li>
            <li>
              <a href="#/tnc" target="_blank">
                {{ $t("Terms of Use") }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
    </div>
  </footer>
</template>
<script>
import { EventBus } from "@/helpers";
import swal from "sweetalert2";

export default {
  components: {},
  props: {
    aimImg: {
      type: String,
      default: "./img/logosm.png"
    },
    fbImg: {
      type: String,
      default: "./img/fb.png"
    },
    twImg: {
      type: String,
      default: "./img/tw.png"
    },
    appleImg: {
      type: String,
      default: "./img/apple.png"
    },
    playImg: {
      type: String,
      default: "./img/play.png"
    },
    inImg: {
      type: String,
      default: "./img/in.png"
    }
  },
  data() {
    return {
      language: "en"
    };
  },
  mounted() {
    this.language = window.localStorage.getItem("locale");
    EventBus.$on("signedup", () => {
      this.showSignup = false;
      swal.fire({
        title: this.$t("Thank You"),
        text: this.$t(
          "You successfully signed up. Please check your email to activate your account!"
        ),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("signedup");
  }
};
</script>
<style></style>
